(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaModule')
        .controller('grcActionPlanCriteriaListController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'notificationService'];

    function Controller($scope, $state, $modal, notificationService) {

        $scope.actionPlanCriterias = $scope.boxModel;
        $scope.actionPlan = $scope.boxContext.ActionPlan;
        $scope.recommendation = $scope.boxContext.Recommendation;
        $scope.ctxActionPlanCriteriaList = {};

        // Add Action Plan Criteria
        $scope.addActionPlanCriteria = function () {
            $state.go('recommendation.edit.actionPlan.edit.actionPlanCriteriaAdd', {
                RecommendationID: $scope.recommendation.RecommendationID,
                ActionPlanID: $scope.actionPlan.ActionPlanID
            });
        };
    }
})();